import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './components/AuthProvider';
import App from './App';
import { initPostHog } from './lib/analytics/posthog';
import './index.css';
import './i18n';

// Initialise analytics once, before first render (module-load timing so no
// $pageview is dropped). No-ops during the headless prerender pass and when no
// token is available — see src/lib/analytics/posthog.ts.
initPostHog();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>
);